import type { FeatureFlagTypes } from '@generated/graphql';
import { UserContext } from '@providers/userContextProvider';
import { useContext, useMemo } from 'react';

export const useOrganizationFeatureFlag = (flag: FeatureFlagTypes) => {
  const { organizationFeatureFlags } = useContext(UserContext);

  return useMemo(
    () => organizationFeatureFlags.has(flag),
    [organizationFeatureFlags, flag],
  );
};
